import React, {useState, useEffect, Fragment, useRef} from 'react'
import Image from '../Image'
import Swiper from 'react-id-swiper';
import parse from 'html-react-parser';
import 'swiper/swiper.scss'
import W from '../Word';
import {isNil, isArray} from 'lodash';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const Slider = ({data, sliderType, config}) => {
    const [swiper, setSwiper] = useState(null);
    const [count, setCount] = useState(null);
    const [forceUpdate, setForceUpdate] = useState(false)
    const [activeSlide, setActiveSlide] = useState(0);
    const { t } = useTranslation();
    //let count = (data && isArray(data)) ? data.length : 0;
    const {pathname} = useLocation();
    const ref = useRef(null);
    //console.log(count, swiper);
    useEffect(() => {
        //setActiveSlide(0);
        if (swiper !== null) {
            /*(swiper.slideTo(0);
            //swiper.pagination.update();
            //swiper.slides = count;
            setActiveSlide(0);
            data = null;
            console.log(swiper);
            swiper.update();*/
        }
        
    }, [pathname])

    useEffect(() => {
        var datacount = (data && isArray(data)) ? data.length : 0;
        setCount(datacount);
        //console.log(datacount);
        if(!isNil(swiper)){
            swiper.imagesLoaded = datacount;
            swiper.slideTo(0);
            //swiper.pagination.update();
            //swiper.slides = count;
            setActiveSlide(0);
            swiper.update();
        }

    }, [data, pathname])

    useEffect(() => {
        if (ref.current !== null && ref.current.swiper !== null) {
            setSwiper(ref.current.swiper);
        }
    }, [ref])
    
    let touchThreshold = 30;
    if(window.innerWidth <= 768 ){
        touchThreshold = 0;
    }

    if(data && isNil(has_video)){
        var has_video = false;
        data.map(item=>{if(item.type == 'video_url'){ has_video = true; }});
    }
    //console.log(has_video);
    const next = () => {
        if(activeSlide !== count-1){
            setActiveSlide(activeSlide+1);
            swiper.slideNext();
        }
        
    };
    
    const createVideoLink = (url) =>{
        if(url.includes('youtube')){
            var video_id = url.split('v=')[1];
            var url = 'https://www.youtube.com/embed/'+video_id+"?rel=0&modestbranding=1&iv_load_policy=3";
            return url;
        }
        if(url.includes('vimeo')){
            var video_id = url.split('.com/')[1];
            var url = 'https://player.vimeo.com/video/'+video_id;
            return url;
        }
    }
    const prev = () => {
        if(activeSlide !== 0){
            setActiveSlide(activeSlide-1);
            if (swiper !== null) {
                swiper.slidePrev();
            }
        }
    };
    
    useEffect(() => {
        //console.log(config);
        if (swiper !== null) {
            swiper.on("slideChange", () => {
                //console.log(swiper.realIndex);
                //console.log(data);
                //console.log(count);
                //console.log(activeSlide);
                //console.log(swiper.allowSlideNext);
                if(activeSlide !== count-1){
                    setActiveSlide(swiper.realIndex);
                    //swiper.touchMoveStopPropagation = true;
                }else{
                    //swiper.touchMoveStopPropagation = false;
                }
            });
        }

        return () => {
            if (swiper !== null) {
                swiper.off("slideChange", () => setActiveSlide(swiper.realIndex));
            }
        };
    }, [swiper]);

    return (
     
        <section className={"carousel__holder "+((config && !isNil(config.className)) ? config.className : "")+((config && config.body && !isNil(config.position)) ? " slider-text-"+config.position : "")+((has_video) ? " carousel__video" : "")}>
        {config && config.body &&
            <div className="text__holder">
                <div className="text">
                    <Fragment>
                        {parse(config.body)}
                    </Fragment>
                </div>
            </div>
        }
        <div className={"carousel"}>
            <ul className="carousel__nav">
                {data && data.length > 1 && count && data.map((item, index)=>{
                    return <li key={index} className={index === activeSlide ? "active" : ""}></li>
                })}
            </ul>
            <div className={"items"}>
                <Swiper threshold={touchThreshold} ref={ref}>
                    {data && data.map((item, index)=>{
                        //console.log(item);
                        if(item.image_url){
                            item.content = item.image_url;
                            item.type = 'image';
                        }
                        if(sliderType == 'product'){
                            var unit_single_plural = t('product.'+item.unit_single+'_interval', {postProcess: 'interval', count: item.total_pieces})
                            var gram_plural = t('product.grameach_interval', {postProcess: 'interval', count: item.total_pieces})
                            //console.log(unit_single_plural, gram_plural);
                        }
                        return (
                            <div id={"sliderItem"+item.slideritem_id} key={index} className={"item"+(!isNil(item.background_color) ? " "+item.background_color : "")+(!isNil(item.custom_class) ? " "+item.custom_class : "")}>
                                {item.type == 'image' &&
                                    <Fragment>
                                        {item.content && 
                                            <Image className="slider-img" src={item.content} responsive={item.responsive_image_url} />
                                        }
                                        {!sliderType &&
                                        <div className="carousel__content">
                                            <Fragment>
                                                {item.body && parse(item.body)}
                                            </Fragment>
                                        </div>
                                        }
                                    </Fragment>
                                }
                                {item.type == 'video_url' &&
                                    <Fragment>
                                        <div className="video">
                                            <iframe className="gruttoYT" src={createVideoLink(item.content)} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="true"></iframe>
                                        </div>
                                    </Fragment>
                                }
                                {sliderType == 'product' && item.shop_title &&
                                <div className="carousel__content">
                                    <Fragment>
                                        {t('product.product_details_slider_item', {title: item.shop_title, total_pieces: item.total_pieces, unit: unit_single_plural, weight: item.weight, gram: gram_plural})}
                                    </Fragment>
                                </div>
                                }
                            </div>
                        )
                    })}
                </Swiper>
            </div>
            {data && data.length > 1 && count &&
            <div className="carousel__bottom">
                <a className={"prev"+(activeSlide > 0 ? " active" : "")} onClick={prev}> <span className="icon-angle-top"></span> </a>
                <a className={"next"+(activeSlide < count-1 ? " active" : "")} onClick={next}> <span className="icon-angle-top"></span> </a>
            </div>
            }
        </div>
        </section>
      
    )
}

export default Slider